export const basePath = "/$__los-ed/";
